import React from 'react';
import { motion } from 'framer-motion';
import { FileText, ClipboardList } from 'lucide-react';
export function ProductPresentation() {
  return <section className="w-full bg-gray-900 py-14 px-4 sm:px-6 lg:px-8 carbon-texture" data-id="element-159">
      <div className="max-w-6xl mx-auto" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-161">
          <h2 className="font-bebas text-4xl sm:text-5xl lg:text-6xl text-white uppercase mb-4 leading-tight" data-id="element-162">
            Después de años trabajando como mecánico,{' '}
            <span className="text-motor-red" data-id="element-163">
              reuní todo lo que realmente funciona
            </span>{' '}
            en un solo sistema práctico
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 items-center" data-id="element-164">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-165">
            <div className="bg-gradient-to-br from-gray-800 to-motor-black border-2 border-motor-red/40 rounded-lg p-6 shadow-red-glow" data-id="element-166">
              <div className="flex items-center justify-center mb-4" data-id="element-167">
                <div className="w-16 h-16 bg-motor-red/20 rounded-full flex items-center justify-center border-2 border-motor-red" data-id="element-168">
                  <FileText className="w-8 h-8 text-motor-red" data-id="element-169" />
                </div>
              </div>
              <h3 className="font-bebas text-3xl text-center text-white uppercase mb-2" data-id="element-170">
                MOTOR 2T PRO
              </h3>
              <p className="text-center text-gray-400 font-montserrat text-sm" data-id="element-171">
                Guía completa paso a paso
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-4" data-id="element-172">
            <div className="bg-gray-800/50 border border-motor-red/30 rounded-lg p-4 hover:border-motor-red/60 transition-all duration-300" data-id="element-173">
              <div className="flex items-start gap-3" data-id="element-174">
                <ClipboardList className="w-7 h-7 text-motor-red flex-shrink-0 mt-0.5" data-id="element-175" />
                <div data-id="element-176">
                  <h4 className="font-bebas text-xl text-white uppercase mb-1" data-id="element-177">
                    Tablas y Planillas
                  </h4>
                  <p className="text-gray-400 font-montserrat text-sm" data-id="element-178">
                    Todo listo para usar: carburación, mezclas, diagnósticos
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-800/50 border border-motor-red/30 rounded-lg p-4 hover:border-motor-red/60 transition-all duration-300" data-id="element-179">
              <div className="flex items-start gap-3" data-id="element-180">
                <ClipboardList className="w-7 h-7 text-motor-red flex-shrink-0 mt-0.5" data-id="element-181" />
                <div data-id="element-182">
                  <h4 className="font-bebas text-xl text-white uppercase mb-1" data-id="element-183">
                    Sistema Probado
                  </h4>
                  <p className="text-gray-400 font-montserrat text-sm" data-id="element-184">
                    Métodos que funcionan en el taller real, no teoría
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}